/* eslint-disable no-param-reassign */
import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';

import Loading from '../../../components/Loading/Loading';
import CardIndex from '../../../card/CardIndex/CardIndex';
import { GAME_CONTENTS } from '../../../config';
import { createAxios, sortSoftsByLocalSoftInit } from '../../../utils/utils';
import { cardInfo, handleCardData } from './Config';
import styles from './GameCardPage.module.less';
import { logging, logPostInfo } from '../../../actions/log';
import ScrollTop from '../../../components/ScrollTop/ScrollTop';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectInstalledSofts = createSelector(
  state => state.native,
  native => native.installedSoft,
);

function CardPage({ code, source, scrollAdv }) {
  const installedSofts = useSelector(selectInstalledSofts);

  const [cards, setCards] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [lock, setLock] = useState(true);
  const [initTime, setInitTime] = useState(Date.now());
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const [logData, setLogData] = useState({ ...logInfoData, source });

  const [pageDom, setPageDom] = useState(null);

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: source || `Game`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: source || `Game`,
        label: '',
        param2: {
          source: source || `Game`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: source || `Game`,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  useEffect(() => {
    if (lock || installedSofts.length <= 0) return;

    setCards(cards => {
      return cards.map(card => {
        if (card.cardType === 'three_parts') {
          card.dataList[0].apps = sortSoftsByLocalSoftInit(card.dataList[0].apps, installedSofts);
        }
        if (card.cardType === 'rank_list_four_row') {
          card.dataList[0].apps = sortSoftsByLocalSoftInit(card.dataList[0].apps, installedSofts);
        }
        return card;
      });
    });
    setLock(true);
  }, [lock, installedSofts]);

  useEffect(() => {
    setCards([]);
    setHasError(false);
    createAxios().then(axios => {
      axios
        .get(GAME_CONTENTS, {
          params: {
            pageType: 'newGame',
            code,
          },
        })
        .then(res => {
          if (res.data.status !== 0 || !res.data.data || res.data.data.length <= 0) {
            throw new Error('no cards.');
          }

          res.data.data = handleCardData(res.data.data);

          if (code === 'gameActivity') {
            setCards(res.data.data);
          } else {
            setCards(res.data.data.sort((a, b) => a.orderNum - b.orderNum));
          }
          setLock(false);
        })
        .catch(() => {
          setHasError(true);
        });
    });
  }, [code]);

  const changView = source => content => {
    dispatch(
      logging({
        category: 'I',
        action: `Game_Content_Show`,
        label: '',
        param2: {
          ...content,
          source: source,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };
  return (
    <div
      className={styles.page}
      data-source={source}
      pagescroll="PCStore_Page_Scroll"
      onScroll={e => {
        if (scrollAdv && typeof scrollAdv === 'function') {
          let adcInView = sessionStorage.getItem('Game_Adv_Is_Show');
          if (e?.target?.scrollTop > 0 && adcInView) {
            scrollAdv();
            e.target.scrollTop = 0;
          }
        }
      }}
      ref={r => setPageDom(r)}
    >
      <div className={styles.page_container}>
        {cards.length > 0 &&
          cards.map((card, index) => {
            const cardLogInfo = cardInfo(source, card);
            const logData = cardLogInfo[card.cardType] || cardLogInfo.default || {};
            return (
              <CardIndex
                key={index}
                data={{
                  ...card,
                  ...(logData.data || {}),
                }}
                logInfo={{
                  ...(logData.logInfo || {}),
                  clTag: 'Game',
                  changView: changView(logData.logInfo.tag || 'Game'),
                }}
              />
            );
          })}
        {!hasError && cards.length <= 0 && (
          <div className={styles.loading}>
            <Loading styleType={'black'} />
          </div>
        )}
        {/* <ScrollTop node={pageDom} quickly={true} /> */}
      </div>
    </div>
  );
}

export default props => {
  return (
    <KeepAlive id={`${props.code}`} name={`game${props.code}`} saveScrollPosition="screen">
      <CardPage {...props} />
    </KeepAlive>
  );
};
